(function () {
  document.querySelectorAll('.shpflt-plans-faq').forEach(function (section) {
    var navLinks = section.querySelectorAll('[data-faq-category]');
    var items = section.querySelectorAll('[data-faq-item-category]');
    var footnoteEl = section.querySelector('[data-faq-footnote]');
    var footnoteText = section.querySelector('[data-faq-footnote-text]');
    var total = parseInt(section.dataset.faqTotal || '0', 10);
    var template = section.dataset.faqMoreTemplate || '';

    function setActiveCategory(category) {
      navLinks.forEach(function (link) {
        var isActive = link.dataset.faqCategory === category;
        link.classList.toggle('shpflt-plans-faq__nav-link--active', isActive);
        link.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      var visibleCount = 0;
      items.forEach(function (item) {
        var matches = item.dataset.faqItemCategory === category;
        if (matches) {
          item.removeAttribute('hidden');
          visibleCount++;
        } else {
          item.setAttribute('hidden', '');
          // Collapse any open answers when leaving the category so re-opening
          // the category starts fresh.
          var btn = item.querySelector('.shpflt-plans-faq__question');
          var ans = item.querySelector('.shpflt-plans-faq__answer');
          if (btn && ans) {
            btn.classList.remove('shpflt-plans-faq__question--open');
            btn.setAttribute('aria-expanded', 'false');
            ans.setAttribute('hidden', '');
          }
        }
      });

      // Auto-open the first visible item in the category so the user sees
      // an answer immediately on switch.
      var firstVisible = section.querySelector('[data-faq-item-category="' + escapeAttr(category) + '"]:not([hidden])');
      if (firstVisible) {
        var btn = firstVisible.querySelector('.shpflt-plans-faq__question');
        var ans = firstVisible.querySelector('.shpflt-plans-faq__answer');
        if (btn && ans) {
          btn.classList.add('shpflt-plans-faq__question--open');
          btn.setAttribute('aria-expanded', 'true');
          ans.removeAttribute('hidden');
        }
      }

      updateFootnote(visibleCount);
    }

    function updateFootnote(visibleCount) {
      if (!footnoteEl || !footnoteText || !template) return;
      var hidden = total - visibleCount;
      if (hidden > 0) {
        footnoteText.textContent = template.replace('{count}', String(hidden));
        footnoteEl.removeAttribute('hidden');
      } else {
        footnoteEl.setAttribute('hidden', '');
      }
    }

    function escapeAttr(str) {
      return String(str).replace(/"/g, '\\"');
    }

    navLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        setActiveCategory(link.dataset.faqCategory);
      });
    });

    // Accordion toggle (delegated for simplicity)
    section.querySelectorAll('.shpflt-plans-faq__question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.shpflt-plans-faq__item');
        if (!item) return;
        var ans = item.querySelector('.shpflt-plans-faq__answer');
        if (!ans) return;
        var isOpen = btn.classList.contains('shpflt-plans-faq__question--open');
        if (isOpen) {
          btn.classList.remove('shpflt-plans-faq__question--open');
          btn.setAttribute('aria-expanded', 'false');
          ans.setAttribute('hidden', '');
        } else {
          btn.classList.add('shpflt-plans-faq__question--open');
          btn.setAttribute('aria-expanded', 'true');
          ans.removeAttribute('hidden');
        }
      });
    });

    // Initialize footnote count based on whatever category is active on render.
    var activeLink = section.querySelector('.shpflt-plans-faq__nav-link--active');
    if (activeLink) {
      var initialCategory = activeLink.dataset.faqCategory;
      var initialVisible = section.querySelectorAll('[data-faq-item-category="' + escapeAttr(initialCategory) + '"]').length;
      updateFootnote(initialVisible);
    } else {
      updateFootnote(total);
    }
  });
})();
